import { render, staticRenderFns } from "./phoneShow.vue?vue&type=template&id=b95e07aa&scoped=true"
import script from "./phoneShow.vue?vue&type=script&lang=js"
export * from "./phoneShow.vue?vue&type=script&lang=js"
import style0 from "./phoneShow.vue?vue&type=style&index=0&id=b95e07aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95e07aa",
  null
  
)

export default component.exports